<template>
	<div>
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1">当前位置：</div>
				<!-- 课程中心
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t1">课程详情</div>
				<el-image :src="require('@/static/icon55.png')"></el-image> -->
				<div class="t2">缴费成功</div>
			</div>
			<div class="r f-ct" @click="goOrder">
				<div class="t2">返回订单列表</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<div class="pageCon">
			<!-- 提示 -->
			<div class="sussMsg f-ct" v-if="userType==1">
				<div class="l">
					<el-image class="bg" :src="require('@/static/icon69.png')"></el-image>
					<p class="t1">缴费成功</p>
					<p class="t2">￥{{pageMsg.price}}</p>
					<div class="hbbtnBox f-ct">
						<div class="b2" @click="link('/fapiaoList')">查看开票信息</div>
						<div class="b1" v-if="userType==1" @click="link('/classList',{id:id})">查看课程详情</div>
						<div class="b1" v-if="userType==2" @click="link('/qyClass',{id:id})">查看课程详情</div>
					</div>
					<p class="t3">课程缴费成功，请耐心等待老师开课</p>
					<p class="t4">具体上课时间会以短信和系统消息进行通知，请留意信息</p>
				</div>
				<div class="r">
					<div class="itm">
						<p class="t1">报名课程：</p>
						<p class="t2">{{pageMsg.courseName}}</p>
					</div>
					<div class="itm">
						<p class="t1">课程培训：</p>
						<p class="t3">{{pageMsg.courseCategoryName}}</p>
					</div>
					<div class="itm">
						<p class="t1">报名时间：</p>
						<p class="t3">{{pageMsg.createTime}}</p>
					</div>
					<div class="itm">
						<p class="t1">付款时间：</p>
						<p class="t3">{{pageMsg.payTime}}</p>
					</div>
					<div class="itm">
						<p class="t1">订单编号：</p>
						<p class="t3">{{pageMsg.orderNo}}</p>
					</div>
					<!-- 企业 -->
					<!-- <div class="itm">
						<p class="t1">缴费人数：</p>
						<p class="t3">5</p>
					</div> -->
				</div>
			</div>
			<div class="sussMsg f-ct" v-if="userType==2">
				<div class="l">
					<el-image class="bg" :src="require('@/static/icon69.png')"></el-image>
					<p class="t1">缴费成功</p>
					<p class="t2">￥{{pageMsg.totalPrice}}</p>
					<div class="hbbtnBox f-ct">
						<div class="b2" @click="link('/fapiaoList')">查看开票信息</div>
						<div class="b1" @click="link('/qyClass',{id:this.id})">查看课程详情</div>
					</div>
					<p class="t3">课程缴费成功，请耐心等待老师开课</p>
					<p class="t4">具体上课时间会以短信和系统消息进行通知，请留意信息</p>
				</div>
				<div class="r">
					<div class="itm">
						<p class="t1">报名课程：</p>
						<p class="t2">{{pageMsg.courseName}}</p>
					</div>
					<div class="itm">
						<p class="t1">课程培训：</p>
						<p class="t3">{{pageMsg.courseCategoryName}}</p>
					</div>
					<div class="itm">
						<p class="t1">报名时间：</p>
						<p class="t3">{{pageMsg.createTime}}</p>
					</div>
					<div class="itm">
						<p class="t1">付款时间：</p>
						<p class="t3">{{pageMsg.updateTime}}</p>
					</div>
					<div class="itm">
						<p class="t1">订单编号：</p>
						<p class="t3">{{pageMsg.orderNo}}</p>
					</div>
					<!-- 企业 -->
					<div class="itm">
						<p class="t1">缴费人数：</p>
						<p class="t3">{{pageMsg.courseOrderList.length}}</p>
					</div>
				</div>
			</div>
			<el-image class="likeImg" :src="require('@/static/icon70.png')"></el-image>
			<!-- 表格 -->
			<div class="biaoge animate__animated animate__fadeIn" data-wow-duration="0.8s">
				<div class="table">
					<div class="th f-ct">
						<p class="t1">序号</p>
						<p class="t2">课程名称</p>
						<p class="t3">课程类型</p>
						<p class="t4">学时</p>
						<p class="t5">收费标准</p>
						<p class="t6">缴费截止日期</p>
						<p class="t7">发布日期</p>
						<p class="t8">操作</p>
					</div>
					<div class="zw" v-if="!msgList.length">
						<el-image :src="require('@/static/zw.png')"></el-image>
						<p>暂无相关数据...</p>
					</div>
					<div class="td f-ct" @click="gokcMsg(item)" v-for="(item,index) in msgList">
						<p class="t1">{{item.id}}</p>
						<div class="t2">
							<span>{{item.name}}</span>
							<el-image v-if="item.isHot" :src="require('@/static/icon20.png')"></el-image>
						</div>
						<p class="t3">{{item.categoryName}}</p>
						<p class="t4">{{item.studyHours}}</p>
						<p class="t5">￥{{item.price}}</p>
						<p class="t6">{{quSFM(item.applyDeadline)}}</p>
						<p class="t7">{{quSFM(item.createTime)}}</p>
						<p class="t8">报名</p>
					</div>
				</div>
				<div class="fenye">
					<el-pagination
					background
					hide-on-single-page
					layout="prev, pager, next,jumper"
					@current-change="goPage"
					:page-size="pageSize"
					:total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { courseOrderdetail,courselist,
courseOrderorderDetail,
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			id:0,
			pageMsg:'',
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 列表
			msgList:[],
		}
	},
	mounted() {
		// 参数
		this.id = this.$route.query.id
		// 获取信息
		this.courseOrderdetail()
		this.courselist(1)
	},
	methods:{
		goOrder(){
			if(this.userType==1){
				this.link('/userOrder')
			}
			if(this.userType==2){
				this.link('/userOrderQY')
			}
		},
		// 获取订单详情
		async courseOrderdetail(){
			let res;
			if(this.userType==1){
				res = await courseOrderdetail({id:this.id});
			}
			if(this.userType==2){
				res = await courseOrderorderDetail({companyOrderId:this.id});
			}
			if(res.code==200){
				let createTime = new Date(res.data.createTime).getTime() + 24 * 60 * 60 * 1000;   //24小时 * 60分钟 * 60秒 * 1000
				res.data.endTime = this.gsTime(createTime)
				this.pageMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
		// 查询课程列表
		async courselist(def){
			if(def){this.pageNum=1}
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
				isHome:1,
			}
			let res = await courselist(data);
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.msgList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.courselist()
		},
		// 跳详情
		gokcMsg(item){
			var pageHistory = ['/userCourse']
			localStorage.setItem("pageHistory", JSON.stringify(this.pageHistory));
			this.link('/userCourseMsg',{id:item.id})
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>

.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
	}
	.r{
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.pageCon{
	margin: 0 40px;
	padding: 24px;
	background: #fff;
	border-radius: 20px;
}
.sussMsg{
	margin-bottom: 32px;
	.l{
		width: 480px;
		height: 326px;
		background: #3B6492;
		position: relative;
		.bg{
			position: absolute;
			top: 0;
			right: 0;
			width: 163px;
		}
		.t1{
			font-size: 24px;
			color: #FFFFFF;
			text-align: center;
			padding-top: 49px;
		}
		.t2{
			font-size: 36px;
			color: #fff;
			text-align: center;
			margin-top: 12px;
		}
		.t3{
			text-align: center;
			color: #fff;
			margin-top: 26px;
			font-size: 14px;
		}
		.t4{
			text-align: center;
			font-size: 14px;
			color: #fff;
			margin-top: 2px;
		}
		.hbbtnBox{
			margin-top: 26px;
			justify-content: center;
			div{
				width: 148px;
				height: 46px;
				border-radius: 8px;
				text-align: center;
				line-height: 42px;
				font-size: 16px;
				border: 2px solid #fff;
				cursor: pointer;
			}
			.b1{
				background: #fff;
				color: #3B6492;
				margin-left: 18px;
			}
			.b2{
				// background: #3B6492;
				color: #fff;
				
			}
		}
	}
	.r{
		width: calc(100% - 480px);
		padding-left: 40px;
		background: #FBFCFF;
		height: 326px;
		padding-top: 32px;
		.itm{
			margin-bottom: 26px;
			display: flex;
			align-items: center;
			.t1{
				font-size: 16px;
				color: #9A9DA7;
			}
			.t2{
				font-size: 16px;
				color: #3B6492;
			}
			.t3{
				font-size: 16px;
				color: #2F3541;
			}
		}
	}
}
.likeImg{
	display: block;
	width: 197px;
	margin: auto;
	margin-bottom: 32px;
}
.biaoge{
	// padding: 24px;
	// padding-top: 0;
	// background: #fff;
	// margin: 0 40px;
	.table{
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		.th{
			height: 40px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				font-weight: bold;
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 526px;
				padding-left: 14px;
				text-align: left;
			}
			.t3{
				width: 210px;
			}
			.t4{
				width: 108px;
			}
			.t5{
				width: 140px;
			}
			.t6{
				width: 165px;
			}
			.t7{
				width: 165px;
			}
			.t8{
				width: 123px;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>p{
				line-height: 56px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0 10px;
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 526px;
				padding-left: 14px;
				text-align: left;
				border-right: 1px solid #EBEEF5;
				line-height: 56px;
				span{
					font-size: 13px;
				}
				.el-image{
					width: 15px;
					height: 18px;
					margin-left: 2px;
					transform: translateY(2px);
				}
			}
			.t3{
				width: 210px;
			}
			.t4{
				width: 108px;
				
			}
			.t5{
				width: 140px;
				color: #FF5F5A;
			}
			.t6{
				width: 165px;
				
			}
			.t7{
				width: 165px;
			}
			.t8{
				width: 123px;
				border: none;
				color: #3B6492;
				cursor: pointer;
			}
		}
	}
	.fenye{
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 26px;
		.i1{
			width: 24px;
			height: 24px;
			margin-right: 6px;
		}
		.fyitm{
			width: 32px;
			height: 32px;
			font-size: 12px;
			text-align: center;
			line-height: 32px;
			margin-right: 6px;
			border-radius: 4px;
		}
		.a{
			background: #3B6492;
			color: #fff;
		}
		.i2{
			width: 24px;
			height: 24px;
			margin-right: 19px;
		}
		.linkPage{
			p{
				font-size: 12px;
			}
			.ipt{
				margin: 0 6px;
				width: 42px;
				height: 32px;
				border-radius: 4px;
				background: #F4F4F4;
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
	}
}
</style>